<template lang="">
  <div>

    <el-tabs v-loading="loading" v-model="listType" element-loading-text="拼命加载中" @tab-click="$forceUpdate()">
      <!-- 作品奖项 -->
      <el-tab-pane label="作品奖项" name="works">
        <div class="search ">
          <el-form :model="searchForm" class="demo-form-inline" size="small" label-width="80px">
            <el-col :span="5" class="formWidth">
              <el-form-item label="作品名称">
                <el-input v-model="searchForm.casename" placeholder="作品名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="formWidth">
              <el-form-item label="活动名称">          
                <el-select v-model="searchForm.competitionid" clearable placeholder="活动名称" @change="GetAwardType(searchForm.competitionid)">
                  <el-option v-for="item in activityList" :label="item.abbrname" :key="item.competitionid" :value="item.competitionid" ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="7" class="formWidth">
              <el-form-item label="奖项分类" style="width: 100%;">
                <el-cascader ref="prizetypeTree" :key="Date.now()" v-model="searchForm.prizeTypeSelect" :options="prizeTypeList2" @change="changeTypeid(searchForm.prizeTypeSelect)" :props="defaultProps" clearable></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="formWidth">
              <el-form-item label="奖项名称">          
                <el-select v-model="searchForm.awardid"  clearable placeholder="奖项名称">
                  <el-option v-for="item in prizeList2" :label="item.awardname" :key="item.awardid" :value="item.awardid"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="10" class="formWidth">
              <el-form-item label="" label-width="0px">          
                <el-radio-group v-model="searchForm.status">
                  <el-radio-button label="">全部</el-radio-button>
                  <el-radio-button label="1">未审核</el-radio-button>
                  <el-radio-button label="2">审核通过</el-radio-button>
                  <el-radio-button label="3">审核不通过</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="formWidth">
              <el-form-item label="" label-width="0px">
                <el-radio-group v-model="searchForm.type">
                  <el-radio-button label="">全部</el-radio-button>
                  <el-radio-button label="1">图文</el-radio-button>
                  <el-radio-button label="2">视频</el-radio-button>
                  <el-radio-button label="3">图文+视频</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            
            <el-col :span="8"  class="formWidth" style="text-align: right;">
              <el-form-item label="" label-width="0px">
                <el-button type="success" @click="search()"><i class="fa fa-search"></i> 查 询</el-button>
                <el-button type="primary" @click="workAdd()"><i class="fa fa-upload"></i> 作品申报</el-button>
              </el-form-item>
              
            </el-col>
            
            <div class="clear"></div>
          </el-form>
    
        </div>
        <div class="clear"></div>
        <div class="list " v-loading="loading">
            <ul v-if="!pc">
              <li v-for="item in list">
                <div class="list_left">
                  <div>
                    <p>                  
                      <span class="workname"><i class="fa fa-bookmark-o"></i>{{item.casename}}</span>
                      <b><span class="worktype" title="作品类别"><i :class="item.type==1?'fa fa-file-pdf-o':'fa fa-file-video-o'"></i>{{item.type|filterType}}</span>
                      <span class="workstatus" title="状态"><i class="fa fa-arrow-right"></i>{{item.casebookstatus|filterStatus}}</span></b>
                    </p>
                    <p>
                      <span class="workprize" title="申报活动"><i class="fa fa-leaf"></i>{{item.comname}}</span>
                      <b><span class="workprize" title="申报奖项"><i class="fa fa-trophy"></i>{{item.awardname}}</span></b>
                      <b><span class="workdate" title="提交时间"><i class="fa fa-clock-o"></i>{{item.bookctime|filterStamp}}</span></b>
                    </p>
                  </div>
                </div>
                <div class="list_right">
                  <el-button size="mini" v-if="item.IsShow" @click="viewfile(item)">查看</el-button>
                  <el-button size="mini" v-if="item.IsUpdate" type="success" plain  @click="workEdit(item)">编辑</el-button>
                  <!-- <el-button size="mini" type="success" plain  @click="workEdit(item)">编辑</el-button> -->
                  <el-button size="mini" v-if="item.IsDelete" type="primary" plain  @click="workDelete(item.casebookid,item.casename)">删除</el-button>
                </div>
              </li>
            </ul>
            <el-table v-if="pc" class="highlight" border :data="list" stripe style="width: 100%">
              <el-table-column prop="casebookid" label="id" width="40" fixed></el-table-column>
              <el-table-column prop="casename" label="案例名称" show-overflow-tooltip width="150"></el-table-column>       
              <el-table-column prop="casebookstatus" label="状态" width="100">
                <template slot-scope="scope">
                  {{scope.row.casebookstatus|filterStatus}}
                </template>
              </el-table-column>          
              <el-table-column prop="awardname" label="参报奖项" show-overflow-tooltip width="300">
                <template slot-scope="scope">
                  <p v-html="scope.row.awardname"></p>
                </template>
              </el-table-column>
              <el-table-column prop="company_title" label="公司名称"  show-overflow-tooltip  width="120"></el-table-column>
              <el-table-column prop="company_name" label="提报公司"  show-overflow-tooltip  width="120"></el-table-column>
              <el-table-column prop="company_type" label="提报公司身份" width="95"></el-table-column>          
              <el-table-column prop="70" label="类型">
                <template slot-scope="scope">
                  {{scope.row.type|filterType}}
                </template>
              </el-table-column>   
              <el-table-column prop="" label="参报活动" show-overflow-tooltip width="150">
                <template slot-scope="scope">
                  <p :title="scope.row.comname">{{scope.row.abbrname}}</p>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="typename" label="奖项分类" show-overflow-tooltip width="120"></el-table-column> -->
              <!-- <el-table-column prop="company_name" label="提报公司" show-overflow-tooltip width="120"></el-table-column>
              <el-table-column prop="company_type" label="提报公司身份" show-overflow-tooltip width="100"></el-table-column>
              <el-table-column prop="" label="联合品牌主" width="82" align="center">
                <template slot-scope="scope">
                  {{scope.row.is_union_brand|filterUnionbrand}}
                </template>
              </el-table-column>
              <el-table-column prop="brand_name" label="品牌名称" show-overflow-tooltip width="100"></el-table-column>
              <el-table-column prop="push_media" label="投放媒体" show-overflow-tooltip width="120"></el-table-column>
              <el-table-column prop="" label="投放时间" show-overflow-tooltip width="170">
                <template slot-scope="scope">
                  {{scope.row.release_time_start}} <b v-if="scope.row.release_time_start">至</b> {{scope.row.release_time_end}}
                </template>
              </el-table-column> -->
              <el-table-column prop="" label="操作" width="130" class-name="oper" fixed="right">
                <template slot-scope="scope">
                  <span v-if="scope.row.IsShow"><a href="javascript:void(0)" @click="viewfile(scope.row)">查看</a></span>
                  <span v-if="scope.row.IsUpdate"> | <a href="javascript:void(0)" @click="workEdit(scope.row)">编辑</a></span>
                  <!-- <span > | <a href="javascript:void(0)" @click="workEdit(scope.row)">编辑</a></span> -->
                  <!-- <span v-if="scope.row.IsCopyright"> | <a href="javascript:void(0)" @click="copyright(scope.row)">版权证明</a></span> -->
                  <span v-if="scope.row.IsDelete"> | <a href="javascript:void(0)" @click="workDelete(scope.row.casebookid,scope.row.casename)">删除</a></span>
                </template>
              </el-table-column>
            </el-table>
        </div>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="total" :current-page="searchForm.page" @current-change="current_change" :page-size="searchForm.length"></el-pagination>
      </el-tab-pane>
      <!-- 个人团队奖项 -->
      <el-tab-pane label="个人团队奖项" name="group">
        <div class="search ">
          <el-form :model="searchForm2" class="demo-form-inline" size="small" label-width="80px">
            <el-col :span="6" class="formWidth">
              <el-form-item label="姓名">
                <el-input v-model="searchForm2.name" placeholder="姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="formWidth">
              <el-form-item label="公司名称">
                <el-input v-model="searchForm2.company" placeholder="公司名称"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" class="formWidth">
              <el-form-item label="奖项名称">          
                <el-select v-model="searchForm2.awardid"  clearable placeholder="奖项名称">
                  <el-option v-for="item in groupAwardList" :label="item.awardname" :key="item.awardid" :value="item.awardid"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6"  class="formWidth" style="text-align: right;">
              <el-form-item label="" label-width="0px">
                <el-button type="success" @click="search2()"><i class="fa fa-search"></i> 查 询</el-button>
                <el-button type="primary" @click="groupAdd()"><i class="fa fa-upload"></i> 个人/团队申报</el-button>
                <!-- <el-button type="success" @click="exportExcel"><i class="fa fa-table"></i> 导出Excel</el-button> -->
              </el-form-item>              
            </el-col>
            <el-col :span="10" class="formWidth">
              <el-form-item label="" label-width="0px">          
                <el-radio-group v-model="searchForm2.status">
                  <el-radio-button label="">全部</el-radio-button>
                  <el-radio-button label="1">未审核</el-radio-button>
                  <el-radio-button label="2">审核通过</el-radio-button>
                  <el-radio-button label="3">审核不通过</el-radio-button>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <div class="clear"></div>
          </el-form>
    
        </div>
        <div class="list" v-loading="loading">
          <el-table v-if="pc" class="highlight" border :data="list2" stripe style="width: 100%">
            <el-table-column prop="id" label="id" width="40"></el-table-column>
            <el-table-column prop="name" label="姓名" show-overflow-tooltip width="90">
              <template slot-scope="scope">
                {{scope.row.name}} <i v-if="scope.row.gender==1" title="男" class="fa fa-mars"></i><i v-if="scope.row.gender==2" title="女" class="fa fa-venus"></i>
              </template>
            </el-table-column>
            <el-table-column prop="age" label="年龄"  show-overflow-tooltip  width="50"></el-table-column>   
            <el-table-column prop="awardname" label="参报奖项" show-overflow-tooltip width="230">
              <template slot-scope="scope">
                <p v-html="scope.row.awardname"></p>
              </template>
            </el-table-column>
            <el-table-column prop="casebookstatus" label="状态" width="80">
              <template slot-scope="scope">
                {{scope.row.casebookstatus|filterStatus}}
              </template>
            </el-table-column>       
            <el-table-column prop="company" label="公司名称"  show-overflow-tooltip  width="170"></el-table-column>
            <el-table-column prop="position" label="职位"  show-overflow-tooltip  width="100"></el-table-column>
            <el-table-column prop="years" label="从业年限" width="80"></el-table-column>          
            <el-table-column prop="" label="操作" width="" class-name="oper">
              <template slot-scope="scope">
                <span v-if="scope.row.button.view"><a href="javascript:void(0)" @click="groupEdit(scope.row,true)">查看</a></span>
                <span v-if="scope.row.button.edit"><a href="javascript:void(0)" @click="groupEdit(scope.row,false)">编辑</a></span>
                <span v-if="scope.row.button.del"> | <a href="javascript:void(0)" @click="groupDel(scope.row)">删除</a></span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="total2" :current-page="searchForm2.page" @current-change="current_change2" :page-size="searchForm2.length"></el-pagination>
      </el-tab-pane>
    </el-tabs>

    <!-- add/edit 作品-->
    <el-dialog :title="(newWorks)?'提交作品':'编辑作品'" :visible.sync="newWorksDialog" :width="dialogWidth1" class="prizeEdit" v-loading="formLoading" :close-on-click-modal="false" top="5vh">
      <div v-loading="this.$store.state.loadingShow">
        <div style="max-height:70vh;overflow-y: auto;overflow-x: hidden;">
          <el-alert v-if="companyStatus==4" title="您的企业未通过认证，无法提交作品" type="error" :closable="false" style="margin-bottom:20px;"></el-alert>
          <el-alert v-if="companyStatus==1" title="您的企业未申请认证，无法提交作品" type="warning" :closable="false" style="margin-bottom:20px;"></el-alert>
          <el-alert v-if="companyStatus==2" title="您的企业认证资料正在审核，现无法提交作品" type="warning" :closable="false" style="margin-bottom:20px;"></el-alert>
          <el-alert v-if="worksInfo.casebookstatus==3" :title="'审核不通过的原因：'+worksInfo.fail_reason" type="error" :closable="false" style="margin-bottom:20px;"></el-alert>
          <el-form :model="worksInfo" ref="worksInfo" size="small" label-width="120px">
            <el-form-item label="所属活动" prop="competitionid" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
              <el-select v-model="worksInfo.competitionid" placeholder="请选择" @change="getPrizeType(worksInfo.competitionid,1)">
                <el-option v-for="item in activityList" :label="item.abbrname" :value="item.competitionid" :key="item.competitionid" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="作品名称" prop="casename" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
              <el-input v-model="worksInfo.casename"></el-input>
            </el-form-item>
            <el-form-item label="作品简介" prop="introduction" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
              <el-input v-model="worksInfo.introduction" type="textarea" :rows="3" maxlength="200" show-word-limit></el-input>
            </el-form-item>
            <template>
              <el-form-item label="公司名称" class="formWidth w50" prop="company_title" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
                <el-input v-model="worksInfo.company_title"></el-input>
              </el-form-item>
              <div class="clear"></div>
              <el-form-item label="提报公司名称" class="formWidth w50" >
                <el-input v-model="worksInfo.company_name"></el-input>
              </el-form-item>
              <el-form-item label="提报公司身份" label-width="120px" class="formWidth w50" >
                <el-select v-model="worksInfo.company_type" placeholder="请选择">
                  <el-option label="代理公司" value="代理公司"></el-option>
                  <el-option label="制作公司" value="制作公司"></el-option>
                  <el-option label="媒体" value="媒体"></el-option>
                  <el-option label="品牌" value="品牌"></el-option>
                </el-select>
              </el-form-item>
            </template>
            <el-form-item label="参赛指南" v-if="worksInfo.entry_guide">
              <a :href="worksInfo.entry_guide" target="_blank">{{worksInfo.entry_guide}}</a>
            </el-form-item>
            <el-form-item label="参赛资料" v-if="worksInfo.entry_materials">
              <a :href="imgBase+worksInfo.entry_materials" target="_blank">{{worksInfo.entry_materials|filterFilename}}</a>
            </el-form-item>
            <el-form-item v-if="prizeTypeList.length>0" label="申报奖项" prop="awardid" :rules="{ required: true, message: '请填写', trigger: 'change' }">          
              <el-tree
                :data="prizeTypeList"
                show-checkbox
                node-key="typeid"
                ref="treeForm"
                :check-strictly="true"
                :default-checked-keys="prizeTypeArr"
                :default-expanded-keys="prizeTypeArr"
                auto-expand-parent
                @check-change="handleNodeClick"
                :props="defaultProps">
              </el-tree>
            </el-form-item>
            <el-form-item v-if="worksInfo.entry_data_type===0" label="作品类型" prop="type" :rules="{ required: true, message: '请填写', trigger: 'change' }">
              <el-radio-group v-model="worksInfo.type" @change="cleanFile()">
                <el-radio-button label="1"><i class="fa fa-file-pdf-o"></i> 图文</el-radio-button>
                <el-radio-button label="2"><i class="fa fa-file-video-o"></i> 视频</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="worksInfo.entry_data_type===1" label="作品类型" prop="type" :rules="{ required: true, message: '请填写', trigger: 'change' }">
              <el-radio-group v-model="worksInfo.type" @change="cleanFile()">
                <el-radio-button label="1"><i class="fa fa-file-pdf-o"></i> 图文</el-radio-button>
                <!-- <el-radio-button label="2"><i class="fa fa-file-video-o"></i> 视频</el-radio-button> -->
                <el-radio-button label="3"><i class="fa fa-file-pdf-o"></i> 图文+<i class="fa fa-file-video-o"></i> 视频</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="图文作品pdf" class="star" v-if="Number(worksInfo.type)==1 || Number(worksInfo.type)==3">
              <el-upload            
                action=""
                :before-upload="handleBeforeUploadPdf"
                :http-request="changeFileUpload"
                :limit="1"
                :file-list="fileList1"
                :on-preview="preview"
                accept=".pdf">
                <el-button size="small" type="primary" @click="filename='file1'">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传pdf文件，不大于10MB</div>
              </el-upload>
            </el-form-item>
            <el-form-item label="图文作品word" class="star" v-if="Number(worksInfo.type)==1 || Number(worksInfo.type)==3">
              <el-upload            
                action=""
                :before-upload="handleBeforeUploadPdf"
                :http-request="changeFileUpload"
                :limit="1"
                :file-list="fileList4"
                :on-preview="preview"
                accept=".doc,.docx">
                <el-button size="small" type="primary" @click="filename='file1'">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传word文件，不大于10MB</div>
              </el-upload>
            </el-form-item>
            <el-form-item label="视频作品" class="star" v-if="Number(worksInfo.type)==2 || Number(worksInfo.type)==3"  >          
              <el-upload            
                action=""
                :before-upload="handleBeforeUploadMp4"
                :http-request="changeFileUpload"
                :limit="1"
                :file-list="fileList2"
                :on-preview="preview"
                accept=".mp4">
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传H264编码格式的mp4文件，不大于100MB</div>
              </el-upload>
            </el-form-item>
            <el-form-item v-if="worksInfo.entry_data_type===1" label="授权确认书" prop="copyright" :rules="{ required: true, message: '请填写', trigger: 'change' }">
              <el-upload            
                action=""
                :before-upload="handleBeforeUploadPdf"
                :http-request="changeFileUpload"
                :limit="1"
                :file-list="fileList3"
                :on-preview="preview"
                accept=".pdf">
                <el-button size="small" type="primary" @click="filename='copyright'">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">请将授权确认书盖章后扫描生成pdf文件，不大于5MB</div>
              </el-upload>
            </el-form-item>

            <el-progress :stroke-width="5" v-show="pFlag" :percentage="progressPercent" style="position: absolute;top:70%;z-index: 2001;width:80%;margin-left:50%;left:-40%;"></el-progress>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="newWorksDialog=false"><i class="fa fa-times"></i> 取 消</el-button>
        <!-- <el-button size="small" type="warning" @click=""><i class="fa fa-save"></i> 暂 存</el-button> -->
        <el-button size="small" v-if="companyStatus==3" type="primary" @click="saveWork('worksInfo')"><i class="fa fa-check"></i> 提 交</el-button>
      </div>
    </el-dialog>

    <!-- add/edit 人物-->
    <el-dialog :title="(newGroup)?'申报人物奖':'编辑人物奖'" :visible.sync="newGourpDialog" :width="dialogWidth1" class="prizeEdit" v-loading="formLoading" :close-on-click-modal="false" top="5vh">
      <div v-loading="this.$store.state.loadingShow">
        <div style="max-height:70vh;overflow-y: auto;overflow-x: hidden;">
          <el-alert v-if="companyStatus==4" title="您的企业未通过认证，无法申报" type="error" :closable="false" style="margin-bottom:20px;"></el-alert>
          <el-alert v-if="companyStatus==1" title="您的企业未申请认证，无法申报" type="warning" :closable="false" style="margin-bottom:20px;"></el-alert>
          <el-alert v-if="companyStatus==2" title="您的企业认证资料正在审核，现无法申报" type="warning" :closable="false" style="margin-bottom:20px;"></el-alert>
          <el-alert v-if="groupInfo.status==3" :title="'审核不通过的原因：'+groupInfo.fail_reason" type="error" :closable="false" style="margin-bottom:20px;"></el-alert>
          <el-form :model="groupInfo" ref="groupInfo" size="small" label-width="120px">
            <el-form-item label="所属活动" prop="competitionid" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
              <el-select v-model="groupInfo.competitionid" placeholder="请选择" @change="getPrizeType(groupInfo.competitionid)" :disabled="groupView">
                <el-option v-for="item in activityList" :label="item.abbrname" :value="item.competitionid" :key="item.competitionid" ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="参赛指南" v-if="groupInfo.entry_guide">
              <a :href="groupInfo.entry_guide" target="_blank">{{groupInfo.entry_guide}}</a>
            </el-form-item>
            <el-form-item label="申报奖项" prop="awardid" :rules="{ required: true, message: '请填写', trigger: 'change' }">          
              <el-checkbox-group v-model="groupInfo.awardid" :max="3" :disabled="groupView">
                <el-checkbox v-for="item in groupAwardList" :label="item.awardid" :key="item.awardid">{{item.awardname}}</el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <template>
              <el-form-item label="姓名" class="formWidth w50" prop="name" :rules="{ required: true, message: '必填', trigger: 'change' }">
                <el-input v-model="groupInfo.name" :disabled="groupView"></el-input>
              </el-form-item>
              <el-form-item label="性别" class="formWidth w50" prop="gender" :rules="{ required: true, message: '必填', trigger: 'change' }">
                <el-radio-group v-model="groupInfo.gender" size="small" :disabled="groupView">
                    <el-radio-button label="1">男</el-radio-button>
                    <el-radio-button label="2">女</el-radio-button>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="生日" class="formWidth w50" prop="birthday" :rules="{required: true, message: '必填', trigger: 'blur'}">
                <el-date-picker type="date" placeholder="选择日期" v-model="groupInfo.birthday" value-format="yyyy-MM-dd" :disabled="groupView"></el-date-picker>
              </el-form-item>
              <el-form-item label="年龄" class="formWidth w50">
                <el-input v-model="age" disabled>
                  <template slot="append">岁</template>
                </el-input>
              </el-form-item>
              <el-form-item label="公司名称" class="formWidth" prop="company" :rules="{ required: true, message: '请填写', trigger: 'blur' }">
                <el-input v-model="groupInfo.company" :disabled="groupView"></el-input>
              </el-form-item>
              <el-form-item label="职位" class="formWidth w50" prop="position" :rules="{required: true, message: '必填', trigger: 'blur'}">
                <el-input v-model="groupInfo.position" :disabled="groupView"></el-input>
              </el-form-item>
              <el-form-item label="从业年限" class="formWidth w50" prop="years" :rules="{required: true, message: '必填', trigger: 'blur'}">
                <el-input v-model="groupInfo.years" :disabled="groupView"></el-input>
              </el-form-item>
              <el-form-item label="详细情况描述" class="formWidth" prop="describe" :rules="{required: true, message: '必填', trigger: 'blur'}">
                <el-input type="textarea" v-model="groupInfo.describe" rows="3" maxlength="2000" show-word-limit :disabled="groupView"></el-input>
              </el-form-item>
              <el-form-item label="个人/团队介绍" class="formWidth" prop="introduction" :rules="{required: true, message: '必填', trigger: 'blur'}">
                <el-input type="textarea" v-model="groupInfo.introduction" rows="3" maxlength="2000" show-word-limit :disabled="groupView"></el-input>
              </el-form-item>
              <el-form-item label="所获荣誉" class="formWidth"  prop="honor" :rules="{required: true, message: '必填', trigger: 'blur'}">
                <el-input type="textarea" v-model="groupInfo.honor" rows="3" maxlength="2000" show-word-limit :disabled="groupView"></el-input>
              </el-form-item>
              <el-form-item label="承诺书" class="formWidth" prop="promise" :rules="{ required: true, validator: validatePromise, trigger: 'change' }">
                <el-checkbox v-model="groupInfo.promise" style="line-height: 32px;" :disabled="groupView">我承诺：</el-checkbox>
                <p>本表中涉及的申报人及提交人承诺以严肃、认真的态度参与本次资料的撰写，为甄选年度品牌领军人物、新品牌营响力人物及杰出团队提供可参考依据。</p>
              </el-form-item>
              <div class="clear"></div>
            </template>            
            <el-form-item label="其他资料">
              <el-upload            
                action=""
                :before-upload="handleBeforeUploadRar"
                :http-request="changeFileUpload"
                :limit="1"
                :file-list="fileList"
                accept=".rar , .zip" :disabled="groupView">
                <el-button size="small" type="primary" @click="filename='copyright'" :disabled="groupView">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">其他可提供的个人资料，如个人简历、相关专访文章等均可上传，压缩成rar或zip格式，不大于10MB</div>
              </el-upload>
            </el-form-item>

            <el-progress :stroke-width="5" v-show="pFlag" :percentage="progressPercent" style="position: absolute;top:70%;z-index: 2001;width:80%;margin-left:50%;left:-40%;"></el-progress>
          </el-form>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="newGourpDialog=false"><i class="fa fa-times"></i> 取 消</el-button>
        <el-button size="small" v-if="companyStatus==3" type="primary" @click="saveGroup('groupInfo')" :disabled="groupView"><i class="fa fa-check"></i> 提 交</el-button>
      </div>
    </el-dialog>

    <!-- copyright -->
    <el-dialog title="版权证明" :visible.sync="copyrightDialog" width="500px">
      <div>
        <el-form :model="copyrightInfo" ref="copyrightInfo" size="small" label-width="80px">
          <el-form-item label="参赛指南" v-if="copyrightInfo.entry_guide">
            <a :href="copyrightInfo.entry_guide" target="_blank">{{copyrightInfo.entry_guide}}</a>
          </el-form-item>
          <el-form-item label="参赛资料" v-if="copyrightInfo.entry_materials">
            <a :href="imgBase+copyrightInfo.entry_materials" target="_blank">{{copyrightInfo.entry_materials|filterFilename}}</a>
          </el-form-item>
          <el-form-item label="版权证明" prop="copyright" :rules="{ required: true, message: '请填写', trigger: 'change' }">
            <el-upload            
              action=""
              :before-upload="handleBeforeUploadPdf"
              :http-request="changeFileUpload2"
              :limit="1"
              :file-list="fileList3"
              :on-preview="preview"
              accept=".pdf">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传pdf文件，不大于5MB</div>
            </el-upload>
          </el-form-item>          
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="copyrightDialog=false"><i class="fa fa-times"></i> 关 闭</el-button>
        <el-button size="small" type="primary" @click="saveCopyright('copyrightInfo')"><i class="fa fa-check"></i> 提 交</el-button>
      </div>
    </el-dialog>

    <!-- view -->
    <el-dialog title="查看作品" :visible.sync="viewDialog" :width="dialogWidth2" top="5vh">
      <div>
        <div class="" style="line-height: 2;margin-bottom:1em;">
          <p>作品名称：{{viewFile.casename}}</p>
        </div>
        <div style="height:70vh;width:100%;-webkit-overflow-scrolling: touch;overflow-y: auto;">
            <el-tabs v-model="activeName" @tab-click="handleClick" style="height: 100%;" class="viewcontent">
              <el-tab-pane label="基本信息" name="info">
                <div class="basicinfo">
                  <p><span class="text-primary">作品名称：</span>{{viewFile.casename}}</p>             
                  <p><span class="text-primary">作品简介：</span>{{viewFile.introduction}}</p>    
                  <p><span class="text-primary">公司名称：</span>{{viewFile.company_title}}</p>    
                  <p><span class="text-primary">提报公司：</span>{{viewFile.company_name}}</p>    
                  <p><span class="text-primary">提报公司身份：</span>{{viewFile.company_type}}</p>
                  <p style="display: flex;"><span class="text-primary">参报奖项：</span><span v-html="viewFile.awardname"></span></p>
                  <p><span class="text-primary">授权确认书：</span></p>
                  <iframe v-if="viewFile.copyright" :src="'/awards/pdf/web/viewer.html?file='+imgBase+viewFile.copyright+'#page=1'" width="100%" :style="viewpdfHeight" ref="" id="" frameborder="0"></iframe>
                </div>
              </el-tab-pane>
              <el-tab-pane v-if="viewFile.type==1||viewFile.type==3" label="图文" name="pdf">
                <!-- <iframe :src="imgBase+viewFile.file_list[0].url" width="100%" :style="viewpdfHeight" ref="" id="" frameborder="0"></iframe> -->
                <a v-if="viewFile.type==1&&viewFile.file_list[1].url" :href="imgBase+viewFile.file_list[1].url" target="_blank"><i class="fa fa-file-word-o"></i> 点击word文件下载查看 <i class="fa fa-download"></i></a>
                <a v-if="viewFile.type==3&&viewFile.file_list[2].url" :href="imgBase+viewFile.file_list[2].url" target="_blank"><i class="fa fa-file-word-o"></i> 点击word文件下载查看 <i class="fa fa-download"></i></a>
                <iframe :src="'/awards/pdf/web/viewer.html?file='+imgBase+viewFile.file_list[0].url+'#page=1'" width="100%" :style="viewpdfHeight" ref="" id="" frameborder="0"></iframe>
              </el-tab-pane>
              <el-tab-pane v-if="viewFile.type==2||viewFile.type==3" label="视频" name="mp4" style="text-align: center;height:100%;">
                <video v-if="viewFile.type==2" :src="imgBase+viewFile.file_list[0].url" style="max-width: 100%;max-height:100%;" preload controls x5-playsinline="true" playsinline="true" webkit-playsinline="true"></video>
                <video v-if="viewFile.type==3" :src="imgBase+viewFile.file_list[1].url" style="max-width: 100%;max-height:100%;" preload controls x5-playsinline="true" playsinline="true" webkit-playsinline="true"></video>
              </el-tab-pane>
            </el-tabs>
        </div> 
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" type="success" @click="viewDialog=false"><i class="fa fa-times"></i> 关 闭</el-button>
      </div>
    </el-dialog>

  </div>
</template>
<script>
  import axios from 'axios'
  import * as API from '@/api/main'
  import * as D from '@/utils/download'
export default {
  data() {
    return {
      loading:false,
      formLoading:false,
      imgBase:this.$store.state.imgBaseUrl,//图片前缀
      // imgBase:"",
      userInfo:JSON.parse(localStorage.getItem("user")),
      total:0,
      total2:0,
      searchForm:{
        page:1,
        length:15,
        status:"",
        type:"",
        prizeTypeSelect:[],
        awardid:"",
      },      
      searchForm2:{
        page:1,
        length:15,
        status:"",
        type:"",
        prizeTypeSelect:[],
        awardid:"",
      },
      worksInfo:{
        typeid:[],      
        awardid:[],
        file:"",//作品路径
        file1:"",//作品路径pdf
        file2:"",//作品路径mp4
        company_title:JSON.parse(localStorage.getItem("user")).company,//
        company_name:"",
        is_union_brand:0,
        release_time:[],        
      },
      newWorks:true,
      newGroup:true,
      newWorksDialog:false,
      newGourpDialog:false,
      activityList:[],
      prizeList:[],
      prizeList2:[],
      list:[],
      list2:[],
      fileList:[],
      fileList1: [],
      fileList2: [],      
      viewDialog:false,
      viewFile:{},
      companyStatus:JSON.parse(localStorage.getItem("user")).status,
      dialogWidth1:"800px",
      dialogWidth2:"1100px",
      defaultProps: {
        children: 'children',
        label: 'typename',
        value:'typeid',
      },
      prizeTypeList:[],
      prizeTypeList2:[],
      prizeTypeArr:[],
      prizeTypeSelect:[],
      pc:true,
      file1:"",
      file2:"",
      copyrightDialog:false,
      copyrightInfo:{
        copyright:"",
        entry_materials:"",
      },
      fileList3:[],
      fileList4:[],
      file3:"",
      activeName:"pdf",
      viewpdfHeight:"height:calc( 70vh - 50px - 22px )",
      pFlag: false,
      progressPercent: 0,
      filename:"",      
      groupInfo:{
        awardid:[],//申报奖项
        name:JSON.parse(localStorage.getItem("user")).name,//姓名
        gender:JSON.parse(localStorage.getItem("user")).gender,//性别
        birthday:"",//生日
        company:JSON.parse(localStorage.getItem("user")).company,//公司
        position:JSON.parse(localStorage.getItem("user")).position,//职位
        years:"",//从业年限
        describe:"",//描述
        introduction:"",//介绍
        honor:"",//荣誉
        promise:false,//承诺
        others:"",//其他资料        
      },
      age:"",
      groupAwardList:[],
      listType:"works",
      groupView:true,
    };
  },
  watch:{

    "searchForm.status":{
      handler: function() {
        this.search()
      },      
    },    

    "searchForm.type":{
      handler: function() {
        this.search()
      },      
    },

    "searchForm2.status":{
      handler: function() {
        this.search2()
      },      
    }, 

    file3(value){
      console.log(value)
    },

    "groupInfo.birthday":{
      handler: function(value) {
        var birthStr = value
        let birthdays = new Date(birthStr.replace(/-/g, "/"));
        let d = new Date();
        let age = d.getFullYear() - birthdays.getFullYear() - (d.getMonth() < birthdays.getMonth() || (d.getMonth() == birthdays.getMonth() && d.getDate() < birthdays.getDate()) ? 1 : 0);
        this.age=age
      },
    }



  },
  filters:{

    //作品状态
    filterStatus(status){
      let str="";
      switch(status){
        case 1:
          str = "未审核";
          return str;
          break;
        case 2:
          str = "审核通过";
          return str;
          break;
        case 3:
          str = "审核不通过";
          return str;
          break;
        default:
          return str;
          break;
      }      
    },

    //作品类型
    filterType(value){
      if(value==1){
        return "图文"
      }else if(value==2){
        return "视频"
      }else if(value==3){
        return "图文+视频"
      }else{
        return ""
      }
    },

    //时间戳转字符串
    filterStamp(timestamp){
      // var t = '1617239226';
      var d = new Date(timestamp * 1000);    //根据时间戳生成的时间对象
      var datetime = (d.getFullYear()) + "-" + 
                (((d.getMonth() + 1)<10)?'0'+(d.getMonth() + 1):(d.getMonth() + 1)) + "-" +
                ((d.getDate())<10?'0'+(d.getDate()):(d.getDate()))+ " " + 
                ((d.getHours())<10?'0'+(d.getHours()):(d.getHours()))+ ":" +
                ((d.getMinutes())<10?'0'+(d.getMinutes()):(d.getMinutes()))+ ":" +
                ((d.getSeconds())<10?'0'+(d.getSeconds()):(d.getSeconds()))
      return datetime;
    },

    //文件名称过滤
    filterFilename(value){
      return value.split("/")[1]
    },

    //是否
    filterUnionbrand(value){
      return (value)?"是":"否"
    }
  },
  methods: {

    //获取列表
    getlist(){
      this.loading=true;
      this.searchForm.is_export=0;
      API.GetMyList(this.searchForm).then(res=>{
        this.list=res.data.data;
        this.loading=false;
        this.total=res.data.total;
      })
    },

    getlist2(){
      this.loading=true;
      this.getGroupAward(14)
      API.getTeamList(this.searchForm2).then(res=>{
        this.list2=res.data.data;
        this.loading=false;
        this.total2=res.data.total;
        // console.log(this.list2)
      })
    },

    //获取活动列表
    getActivityList(){
      this.loading=true;
      let postdata={
        page:1,
        length:100,
        status:"",
      }
      API.GetActivityList(postdata).then(res=>{
        this.activityList=res.data.data;
        this.searchForm.competitionid=this.activityList[0].competitionid;
        this.GetAwardType(this.searchForm.competitionid)
        this.getlist();
      })
    },

    //分页
    current_change(currentPage){
      this.searchForm.page = currentPage;
      this.getlist();
    },
    current_change2(currentPage){
      this.searchForm2.page = currentPage;
      this.getlist2();
    },

    //查询
    search(){
      this.current_change(1);
    },
    search2(){
      this.current_change2(1);
    },

    //导出Excel
    // exportExcel(){
    //   this.loading=true;
    //   this.searchForm.is_export=1;
    //   API.GetMyList(this.searchForm).then(res=>{
    //     this.loading=false;
    //   })
    // },
    
    exportExcel: _.debounce(function () {
      this.loading = true
      this.searchForm.is_export=1;
      D.down( "/index/Search/casebooksearch" , this.searchForm ).then(response => {
        D.load( response , "我的作品列表.csv" )
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }, 500),
    
    //重置校验
    resetForm(formName) {
        this.$refs[formName].resetFields();
    },

    //获取奖项列表
    getPrize(n){
      let id;
      if(n==1){
        id=this.worksInfo.competitionid
      }else if(n==2){
        id=this.searchForm.competitionid
      }
      
      if(id){
        API.GetPrizeListByAct({competitionid:id}).then(res=>{
          if(n==1){
            this.prizeList=res.data;
            
          }else if(n==2){
            this.prizeList2=res.data;
          }else{

          }        
          // console.log(res)
        })
      }else{
        if(n==1){
          this.worksInfo.awardid=""
          this.prizeList=[];          
        }else if(n==2){
          this.searchForm.awardid=""
          this.prizeList2=[];
        }
      }
    },

     // 上传文件之前的钩子mp4
     handleBeforeUploadMp4(file){
      // console.log(file.size)
      let size = file.size / 1024 / 1024 ;
      if(size > 100) {
          this.$message({
              type: 'warning',
              message: 'mp4文件大小必须小于100M'
          });
          return false;
      }
      if(!(file.type === 'video/mp4')) {
          this.$message({
              type: 'warning',
              message: '请上传格式为mp4的文件'
          });
          return false;
      }
    },

    // 上传文件之前的钩子pdf
    handleBeforeUploadPdf(file){
      // console.log(file.size)
      let size = file.size / 1024 / 1024 ;
      if(size > 10) {
          this.$message({
              type: 'warning',
              message: 'pdf文件大小必须小于10M'
          });
          return false;
      }
      console.log(file.type)
      if(!((file.type === 'application/pdf') || (file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')||(file.type === '')||(file.type==="application/wps-writer"))) {
          this.$message({
              type: 'warning',
              message: '请上传格式为pdf或word的文件'
          });
          return false;
      }
    },

    // 上传文件之前的钩子zip/rar
    handleBeforeUploadRar(file){
      // console.log(file.size)
      let size = file.size / 1024 / 1024 ;
      let filename=file.name;
      if(size > 10) {
          this.$message({
              type: 'warning',
              message: '文件大小必须小于10M'
          });
          return false;
      }
      console.log(file)
      var pos = filename.lastIndexOf(".");
      var lastname = filename.substring(pos,filename.length); 
      if ((lastname.toLowerCase() != ".zip" )&&(lastname.toLowerCase() != ".rar")){
        this.$message({
            type: 'warning',
            message: '请上传格式为zip或rar的压缩包文件'
        });
        return false;
      }
    },

    //上传附件
    // changeFileUpload(options) {
    //   this.$store.state.loadingShow=true;
    //   let file = options.file
    //   // console.log(file)
    //   let type=file.type;
    //   var postdata = new FormData();      
    //   if(type=="application/pdf"){
    //     postdata.append('filepdf', file);
    //     API.UploadFile(postdata).then(res=>{
    //       this.worksInfo.file1=res.path;
    //       this.file1=res.path;
    //       this.$store.state.loadingShow=false;
    //     })
    //   }else if(type=="video/mp4"){
    //     postdata.append('filemp4', file);
    //     API.UploadFile(postdata).then(res=>{
    //       this.worksInfo.file2=res.path;
    //       this.file2=res.path;
    //       this.$store.state.loadingShow=false;
    //     })
    //   }else{
    //     this.$store.state.loadingShow=false;
    //   }
    // },

    changeData (file, fileList) {
       // 数据小于0.1M的时候按KB显示
      const size = file.size/1024/1024 > 0.1 ? `(${(file.size/1024/1024).toFixed(1)}M)` : `(${(file.size/1024).toFixed(1)}KB)`
      file.name.indexOf('M')>-1 || file.name.indexOf('KB')>-1 ? file.name : file.name += size
    },

    //上传附件
    changeFileUpload(options) {
      this.$store.state.loadingShow=true;
      let file = options.file;
      let filename=file.name;
      var pos = filename.lastIndexOf(".");
      var lastname = filename.substring(pos,filename.length);
      let type=file.type;
      var postdata = new FormData();
      this.pFlag=true
      postdata.append('file', file);
      const config = {
        onUploadProgress: progressEvent => {
          // progressEvent.loaded:已上传文件大小
          // progressEvent.total:被上传文件的总大小
          this.progressPercent = parseInt((progressEvent.loaded / progressEvent.total * 100)-5)
        }
      }
      var BrowserUrl=window.location.href;
      var baseURLStr=""
      if(BrowserUrl.includes('localhost') || BrowserUrl.includes('192.168.6')){
        baseURLStr="/api";
      }else{
        baseURLStr="/api";
      }
      axios.interceptors.request.use(function (config) {
        if( window.localStorage.getItem("token") ){
          config.headers.token = window.localStorage.getItem("token")
        }
        return config
      }, function (error) {
        console.log(error) // for debug
        Promise.reject(error)
      });
      axios.post(baseURLStr+'/index/Membership/upload_video_Pdf',postdata,config).then(res => {  
        if (res.data.code==200) {          
          this.progressPercent=100
          if(type=="application/pdf"){ 
            if(this.filename=='file1'){
              this.worksInfo.file1=res.data.path;
              this.file1=res.data.path;
            }else if(this.filename=='copyright'){
              this.worksInfo.copyright=res.data.path;
            }
          }
          if(type=="video/mp4"){             
            this.worksInfo.file2=res.data.path;
            this.file2=res.data.path;            
          }
          if(type=="application/vnd.openxmlformats-officedocument.wordprocessingml.document"){
            this.worksInfo.file3=res.data.path;
            this.file3=res.data.path;
          }
          if((lastname.toLowerCase() == ".zip" )||(lastname.toLowerCase() == ".rar")){
            this.groupInfo.others=res.data.path;
          }
          
          setTimeout(()=>{
            this.$store.state.loadingShow=false;
            this.pFlag=false
            this.progressPercent=0;
          }, 1000)
        }else{
          this.$message({
            message: res.data.info,
            type: 'error',
          })
          this.$store.state.loadingShow=false;
          this.pFlag=false
          this.progressPercent=0;
        }
      })
    },

    //上传版权证明
    changeFileUpload2(options){
      this.loading=true;
      let file = options.file;
      var postdata = new FormData();
      postdata.append('filepdf', file);
      API.UploadFile(postdata).then(res=>{
        this.copyrightInfo.copyright=res.path;
        this.file3=res.path;
        this.loading=false;
      })
    },

    //上传版权证明
    changeFileUpload3(options){
      this.loading=true;
      let file = options.file;
      var postdata = new FormData();
      postdata.append('filepdf', file);
      API.UploadFile(postdata).then(res=>{
        this.worksInfo.copyright=res.path;
        this.file3=res.path;
        this.loading=false;
      })
    },

    //清除附件
    cleanFile(){
      this.worksInfo.file1="";
      this.worksInfo.file2="";
      this.worksInfo.file3="";
      this.file1="";
      this.file2="";      
      this.file3="";
      this.fileList1=[];
      this.fileList2=[];
    },

    cleanFilePdf(file,fileList){
      if (file && file.status==="success") {
        //移除方法
        this.worksInfo.file1="";
      }
    },

    cleanFileMp4(file,fileList){
      if (file && file.status==="success") {
        //移除方法
        this.worksInfo.file2="";
      }
    },

    //新增
    workAdd(){
      this.newWorks=true;
      this.newWorksDialog=true;
      this.prizeList=[];
      this.fileList1=[];
      this.fileList2=[];
      this.prizeTypeList=[];
      this.prizeTypeArr=[];
      this.worksInfo={
        casename:"",//作品名称
        introduction:"",//作品描述
        competitionid:this.activityList[0].competitionid,//所属活动
        awardid:[],//申报奖项
        typeid:[],//所属分类
        type:"",//作品类型
        file:"",//作品路径
        file1:"",//作品路径pdf
        file2:"",//作品路径mp4
        file3:"",//作品word
        casebookid:"",//作品id
        entry_data_type:"",// 图文视频0单选1多选
        entry_guide: "",// 参赛指南
        entry_materials: "", // 参赛资料
        company_title:JSON.parse(localStorage.getItem("user")).company,
        company_name:"",//提报公司
        company_type:"",//提报公司身份
        is_union_brand:false,//是否联合品牌主报奖
        brand_name:"",//品牌名称
        release_time:[],//案例投放时间段
        push_media:"",//投放媒体
        copyright:"",//版权证明
      }
        this.getPrizeType(this.worksInfo.competitionid,1)
    },

    //编辑
    workEdit(item){
      this.formLoading=true;
      this.newWorks=false;
      this.fileList1=[];
      this.fileList2=[];
      this.fileList3=[];
      this.fileList4=[];
      this.worksInfo={
        casename:item.casename,//作品名称
        introduction:item.introduction,//作品描述
        competitionid:item.competitionid,//所属活动
        awardid:item.awardid,//申报奖项
        type:item.type,//作品类型
        file:item.file,//作品路径
        casebookid:item.casebookid,//作品id
        entry_data_type:item.entry_data_type,// 图文视频0单选1多选
        entry_guide: item.entry_guide,// 参赛指南
        entry_materials: item.entry_materials, // 参赛资料
        company_title:item.company_title,//公司名称
        company_name:item.company_name,//提报公司名称
        company_type:item.company_type,//提报公司身份
        is_union_brand:item.is_union_brand,//是否联合品牌主报奖
        brand_name:item.brand_name,//品牌名称
        release_time:item.release_time,//案例投放时间段
        file1:"",//pdf
        file2:"",//mp4
        file3:"",//word
        push_media:item.push_media,//投放媒体
        casebookstatus:item.casebookstatus,//作品状态
        copyright:item.copyright,//版权证明
        fail_reason:item.fail_reason,//审核不通过的原因
      }
      API.GetAwardType({competitionid:item.competitionid,is_data:1,casebookid:item.casebookid}).then(res=>{
        this.prizeTypeList=_.cloneDeep(res.list);
        console.log(this.prizeTypeList)
        this.prizeTypeArr=item.awardid;
        this.$forceUpdate();
        this.formLoading=false;
      })
      var file=item.file_list;
      for(let i=0;i<file.length;i++){
        let filetype=file[i].type;
        if(filetype=="pdf"){
          this.fileList1.push(file[i])
          this.worksInfo.file1=file[i].url;
          this.file1=file[i].url;
        }else if(filetype=="mp4"){
          this.fileList2.push(file[i]);          
          this.worksInfo.file2=file[i].url;
          this.file2=file[i].url;
        }else if(filetype=="doc"){
          this.fileList4.push(file[i]);
          this.worksInfo.file3=file[i].url;
          this.file3=file[i].url;
        }
      }
      if(item.copyright){
        this.fileList3.push({
          url:item.copyright,
          name:item.copyright.split("/")[1]
        })
      }
      // console.log(this.file1,this.file2)
      this.newWorksDialog=true;      
    },

    //提交
    saveWork(formName){
      this.worksInfo.file="";
      this.worksInfo.file1=this.file1;
      this.worksInfo.file2=this.file2;
      this.worksInfo.file3=this.file3;
      if(Number(this.worksInfo.type)==1){
        this.worksInfo.file=this.worksInfo.file1+","+this.worksInfo.file3;
      }else if(Number(this.worksInfo.type)==2){
        this.worksInfo.file=this.worksInfo.file2;
      }else{
        this.worksInfo.file=this.worksInfo.file1+","+this.worksInfo.file2+","+this.worksInfo.file3;
      }
      console.log(this.worksInfo);
      this.$refs[formName].validate((valid) => {
          if (valid) {
            // console.log(this.worksInfo);
            this.$confirm('点击【提交】后，作品进入审核阶段，期间作品可删除但无法修改；若作品审核不通过可以修改作品，若作品审核通过则无法修改或删除作品，请谨慎提交。', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              if(this.newWorks){              
                API.WorksAdd(this.worksInfo).then(res=>{
                  this.$message({
                    message: res.info,
                    type: 'success'
                  });
                  this.newWorksDialog=false;              
                  this.resetForm(formName);
                  this.search();
                })
              }else{
                API.WorksEdit(this.worksInfo).then(res=>{
                  this.$message({
                    message: res.info,
                    type: 'success'
                  });
                  this.newWorksDialog=false;              
                  this.resetForm(formName);
                  this.getlist();
                })
              }
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              });          
            });
          } else {
            return false;
          }
        });
    },

    //删除
    workDelete(id,name){
      this.$confirm('确定删除“'+name+'”作品?', '提示', {
          confirmButtonText: '确 定',
          cancelButtonText: '取 消',
          type: 'warning'
        }).then(() => {
          API.WorksDelete({casebookid:id}).then(res=>{        
            this.$message({
              message: '作品已删除',
              type: 'success',
            })
            this.getlist();
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },

    //查看文件
    viewfile(item){
      this.viewFile=item;
      // console.log(this.viewFile)
      this.viewDialog=true;
    },

    diffrentScreen(){
      if(document.body.clientWidth<1200){
        this.dialogWidth1="100vw";
        this.dialogWidth2="100vw";
      }
    },

    //获取分类列表
    getPrizeType(id,n){
      
      if(id){
        API.GetAwardType({competitionid:id,is_data:1,is_disabled:n}).then(res=>{
          if(n==1){
            
            var obj=_.find(this.activityList,['competitionid',Number(id)]);
            this.prizeTypeList=_.cloneDeep(res.list);
            this.worksInfo.entry_data_type=obj.entry_data_type;
            this.worksInfo.entry_guide=obj.entry_guide;
            this.worksInfo.entry_materials=obj.entry_materials;
            this.worksInfo.type="";
            this.worksInfo.awardid=[];
          }else if(n==2){
            this.prizeTypeList2=_.cloneDeep(res.list);            
            for(var i=0;i<this.prizeTypeList2.length;i++){              
              this.prizeTypeList2[i].disabled=false;
              if(this.prizeTypeList2[i].children.length>0){
                for(var j=0;j<this.prizeTypeList2[i].children.length;j++){
                  this.prizeTypeList2[i].children[j].disabled=false;
                  delete this.prizeTypeList2[i].children[j].children
                }
              }else{
                delete this.prizeTypeList2[i].children;
              }
            }
          }        
          this.$forceUpdate();
          // console.log(this.prizeTypeList2)
        })
      }else{
        if(n==1){
            this.prizeTypeList=[];
          }else if(n==2){
            this.prizeTypeList2=[];
            this.searchForm.prizeTypeSelect=[];
            this.searchForm.typeid="";
          }
      }      
    },

    //树
    handleNodeClick(data, checked, node) {
      // console.log(this.$refs.treeForm.getCheckedKeys());
      this.prizeList=[];
      this.worksInfo.awardid=[];
      this.worksInfo.awardid=_.cloneDeep(this.$refs.treeForm.getCheckedKeys())
      //console.log(this.worksInfo.awardid);
      for(var i=0;i<this.prizeTypeList.length;i++){
        for(var j=0;j<this.prizeTypeList[i].children.length;j++){
          var id=this.prizeTypeList[i].children[j].awardid;
          if(this.worksInfo.awardid.length>=3){
            if(this.worksInfo.awardid.indexOf(id) ==-1) {
              this.prizeTypeList[i].children[j].disabled=true;
            }
          }else{
            this.prizeTypeList[i].children[j].disabled=false;
          }
        }
      }
      this.$forceUpdate();
      //console.log(this.prizeTypeList)
    },

    //search获取typeID
    // changeTypeid(arr){
    //   this.searchForm.awardid="";
    //   if(arr.length>0){
    //     this.searchForm.typeid=arr[arr.length-1];
    //     var obj=this.$refs["prizetypeTree"].getCheckedNodes()[0].data;
    //     this.prizeList2=_.cloneDeep(obj.list)
    //   }else{
    //     this.prizeList2=[]
    //   }      
    // },

     //获取分类列表
    GetAwardType(id){
      this.prizeTypeList2=[];
      this.searchForm.typeid="";
      this.searchForm.awardid="";
      this.prizeList2=[]
      this.searchForm.prizeTypeSelect=[];
      if(id){        
        API.GetAwardTypeList({competitionid:id}).then(res=>{
          this.prizeTypeList2=res.data;
        })
      }      
    },

    //search获取typeID
    changeTypeid(arr){
      console.log(arr)
      this.searchForm.awardid="";
      if(arr.length>0){
        this.searchForm.typeid=arr[arr.length-1];
        var obj=this.$refs["prizetypeTree"].getCheckedNodes()[0].data;
        this.prizeList2=_.cloneDeep(obj.awards)
      }else{
        this.prizeList2=[]
        this.searchForm.typeid="";
      }
    },


    //版权证明
    copyright(item){
      this.copyrightDialog=true;
      this.copyrightInfo={
        casebookid:item.casebookid,
        entry_materials:item.entry_materials,
        copyright:item.copyright,
        entry_guide:item.entry_guide,
      }
      if(item.copyright){
        this.fileList3.push({
          url:item.copyright,
          name:item.copyright.split("/")[1]
        })
      }      
    },

    //版权证明提交
    saveCopyright(formName){
      // console.log(this.file3);
      this.copyrightInfo.copyright=this.file3;
      // console.log(this.copyrightInfo)
      this.$refs[formName].validate((valid) => {
          if (valid) {
            // console.log(this.worksInfo);
            this.$confirm('点击【提交】后，版权证明进入审核阶段，期间，作品和版权证明均无法修改；作品和版权证明上传完成并审核通过即完成报名，之后无法修改或删除作品，请谨慎提交。', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
                API.SaveCopyright(this.copyrightInfo).then(res=>{
                  this.$message({
                    message: res.info,
                    type: 'success'
                  });
                  this.copyrightDialog=false;              
                  this.resetForm(formName);
                  this.getlist();
                })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              });          
            });
          } else {
            return false;
          }
        });
    },

    //下载附件
    preview(file){
      if(file.url){
        window.open(this.imgBase+file.url)
      }
      // console.log(file.url)      
    },

    //查看切换选项卡
    handleClick(){
      this.viewpdfHeight="0";
      setTimeout(() => {
        this.viewpdfHeight="height:calc( 70vh - 50px )";
      }, 0);
    },
    
    //校验承诺书
    validatePromise(rule, value, callback) {
      if (!value) {
        return callback(new Error('请勾选承诺书')) ;
      }else {
          callback();
        }
    },

    //新增
    groupAdd(){
      this.newGroup=true;
      this.newGourpDialog=true;
      this.groupView=false;
      this.prizeList=[];
      this.fileList1=[];
      this.fileList2=[];
      this.groupAwardList=[];
      this.prizeTypeArr=[];
      this.groupInfo={
        competitionid:this.activityList[0].competitionid,//所属活动
        awardid:[],//申报奖项
        name:JSON.parse(localStorage.getItem("user")).name,//姓名
        gender:JSON.parse(localStorage.getItem("user")).gender,//性别
        birthday:"",//生日
        company:JSON.parse(localStorage.getItem("user")).company,//公司
        position:JSON.parse(localStorage.getItem("user")).position,//职位
        years:"",//从业年限
        describe:"",//描述
        introduction:"",//介绍
        honor:"",//荣誉
        promise:false,//承诺
        others:"",//其他资料       
        fail_reason:"", 
        status:"",
      }
      this.fileList=[]
      this.getGroupAward(this.groupInfo.competitionid)
      // this.resetForm('groupInfo')
    },

    //编辑
    groupEdit(item,view){
      this.formLoading=true;
      this.groupView=view;
      this.newGroup=false;
      this.fileList=[];
      this.groupInfo={
        id:item.id,
        competitionid:item.competitionid,//所属活动
        awardid:item.award_ids,//申报奖项
        name:item.name,//姓名
        gender:item.gender,//性别
        birthday:item.birthday,//生日
        company:item.company,//公司
        position:item.position,//职位
        years:item.years,//从业年限
        describe:item.describe,//描述
        introduction:item.introduction,//介绍
        honor:item.honor,//荣誉
        promise:item.promise,//承诺
        others:item.others,//其他资料
        fail_reason:item.fail_reason,
        status:item.status,
      }
      this.age=item.age;
      this.fileList=item.file_list;
      this.newGourpDialog=true;
      this.formLoading=false;
    },


    //提交
    saveGroup(formName){
      this.$refs[formName].validate((valid) => {
        console.log(this.groupInfo);
          if (valid) {
            this.$confirm('点击【提交】后，申请进入审核阶段，期间申请可删除但无法修改；若审核不通过可以修改，若审核通过则无法修改或删除申请，请谨慎提交。', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              if(this.newWorks){              
                API.saveGroup(this.groupInfo).then(res=>{
                  this.$message({
                    message: res.info,
                    type: 'success'
                  });
                  this.newGourpDialog=false;                  
                  this.resetForm(formName);
                  this.search2();
                })
              }
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消提交'
              });          
            });
          } else {
            return false;
          }
        });
    },

    //删除团队
    groupDel(item){
      var postdata={
        id:item.id,
        competitionid:item.competitionid,
        act:"del"
      }
      this.$confirm('确定删除这条数据?', '提示', {
        confirmButtonText: '确 定',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        API.saveGroup(postdata).then(res=>{        
          this.$message({
            message: '已删除',
            type: 'success',
          })
          this.getlist2();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },

    //获取分类列表
    getGroupAward(id){
        API.getTeamAward({competitionid:id}).then(res=>{ 
          this.groupAwardList=_.cloneDeep(res.data);
          this.$forceUpdate();
        })
    },

  },
  created() {
    
    this.getlist2();
    this.getActivityList();
    this.diffrentScreen();
    if(document.body.clientWidth>1200){
      this.pc=true;
    }else{
      this.pc=false;
    }
  },
}
</script>
<style scoped>
    .search{padding-bottom:20px;border-bottom: 1px #eee solid;}
.list {line-height: 2;;}
.list ul li{display:flex;justify-content:space-between;align-items:center;padding:10px;border-bottom: 1px solid #e7e7e7;}
.list ul li:nth-of-type(even){    background: #f6f6f6;}
.list ul li:hover{background:var(--mainColorOp)}
.list .list_left{display: flex;}
.list .list_left .checkbox{margin-right:5px;}
.list span{margin-right:1em;}
.list i.fa{color:var(--mainColor);margin-right:5px;width:16px;text-align: center;display: inline-block;}
.list span.workname{font-size:1em;}
.list span.workprize u{color:#999;}
.prizeEdit .el-checkbox{line-height: 2;margin:0;display:block;}
.list td.oper span{margin:0;}
.w50{width: 50%;}
.basicinfo{background-color: var(--mainColorOp);padding:2em 3em;line-height: 2;border-radius: 4px;}
@media screen and (max-width: 1200px){
  .formWidth{width:100%;}
  .list ul li{display: block;}
  .list_right{padding-left:15px;}
  .list b{display:block;}
}
</style>